import { BlockType } from '@next-space/fe-api-idl';
import { useCallback } from 'react';
import { addBlock } from 'src/redux/managers/block/add';

import { useTransaction } from '../use-transaction';

/**
 * 创建新记录, 默认不排序
 * @returns
 */
export const useCreateRecord = () => {
  const transaction = useTransaction();
  const createRecord = (collectionId: string) => {
    return transaction(() => {
      const id = addBlock(
        {
          type: BlockType.PAGE,
          data: {
            segments: [],
            collectionProperties: {},
          },
        },
        { parentId: collectionId, last: true }
      );
      return id;
    });
  };

  return useCallback(createRecord, [transaction]);
};
